import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import news from '../../assets/img/news/news1.jpg'
import cellbank from '../../assets/img/news/cellbank_news.jpg'
import cellbank2 from '../../assets/img/news/news.png'
import stem from '../../assets/img/news/stem.png'
import stemMain from '../../assets/img/news/genetic_service.png'
import hair from '../../assets/img/news/hair.png'
import ernst from '../../assets/img/news/ernst.png'
import shinya from '../../assets/img/news/shinya.png'
import uudel_es from '../../assets/img/news/uudel_es.png'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import logo from '../../assets/img/logo_small.png'
import door from '../../assets/img/icon/door.png'
import Header from '../Header'
import { useParams } from 'react-router-dom'
import open from '../../assets/img/news/open_new.jpg'
import blood from '../../assets/img/news/blood.png'
import blood2 from '../../assets/img/news/blood_2.jpg'
import blood4 from '../../assets/img/news/blood4.jpg'
import blood3 from '../../assets/img/news/blood3.png'
import sc2 from '../../assets/img/news/sc2.png'
import sc2_1 from '../../assets/img/news/sc2_family.png'
import sc2_u from '../../assets/img/news/sc2_u.png'
import sc2_es from '../../assets/img/news/sc2_es.png'

const newsList = [
  {
    id: 1,
    content: {
      date: '2025/01/10',
      headerText:
        'Монгол Улсад анх удаа үүдэл эсийн банк болон эсийн эмчилгээний бүтээгдэхүүн үйлдвэрлэх хамгийн орчин үеийн дэвшилтэт технологийг нэвтрүүлсэн Селл Клиник эмнэлэг албан ёсоор үйл ажиллагаагаа эхлүүллээ. ',
      highlightText: '',
      p1: 'Манай эмнэлэг нь олон улсын GMP лабораторийн стандартын дагуу эс боловсруулах, хадгалах, эсийн эмчилгээний үйлчилгээг санал болгож байна.  ',
      img1: news,
      img1_title: '',
      highlightText2: '',
      p2: 'Таны эрүүл мэндэд зориулсан энэхүү дэвшилтэт технологи нь аливаа өвчин эмгэгийг эдгээх боломжийг тэлэх бөгөөд өндөр чанартай үйлчилгээг Монголдоо авах нөхцөлийг бүрдүүлж өгнө.',
      highlightText3: '',
      p3: 'Бидний бахархал болсон баг хамт олон нь анагаах ухаан, биотехнологи, лабораторийн чанарын баталгаа, эс боловсруулах, эсийн эмчилгээний чиглэлээр өндөр хөгжилтэй орнуудад мэргэшсэн, 10+ жилийн судалгаа, шинжилгээ, бизнесийн туршлагатай мэргэжилтнүүдээс бүрддэг.',
      ul: '',
      img2: open,
      img2_title: '',
      p4: 'Манай эмнэлэг нь Улаанбаатар хотын төвд, Улсын их дэлгүүрийн зүүн талд байрлах Гандирс цогцолборын 3 дугаар давхарт байрлаж байна. ',
      p5: 'Селл Клиник эмнэлэг нь амьд эсийг ашиглан дэлхийн хамгийн дэвшилтэт эмчилгээний аргуудыг Монголын ард түмэнд ойртуулж, эсийн банк болон эмчилгээ үйлчилгээг бүрэн хэмжээнд нэвтрүүлэхэд бэлэн боллоо. Танд эрүүл мэндийн шинэ эрин үеийг нээх боломжийг хамтдаа бүрдүүлцгээе! '
    }
  },
  {
    id: 2,
    content: {
      date: '2025/02/05',
      headerText: 'Эсийн банк гэж юу вэ? ...Яагаад чухал вэ?',
      highlightText: '',
      p1: 'Эсийн банк гэдэг нь ирээдүйд эмчилгээ, судалгаанд ашиглах зорилгоор эсийг цуглуулан, боловсруулж хадгалдаг эрүүл мэндийн байгууллагыг хэлнэ. Энэ нь эрүүл мэндийн салбар болон биотехнологийн салбарт найдвартай, тогтвортой эсийн нөөцийг бүрдүүлэх чухал ач холбогдолтой.',
      img1: cellbank,
      img1_title: '',
      highlightText2: '',
      p2: 'Дэлхий дахинд хүний үүдэл эс, бэлгийн эс, дархлааны эсийн гэх мэтчилэн олон төрлийн эсийг хадгалдаг эсийн банкнууд байдгаас хамгийн түгээмэл нь хүйн цус, эдийн үүдэл эсийг хадгалдаг банкнууд юм. ',
      highlightText3:
        'Яагаад хүйн цус, эдийн үүдэл эсийг илүү чухалчлан хадгалдаг болсон бэ?',
      p3: 'Хүйн цус болон хүйн эдийн үүдэл эсийг хадгалж буй гол шалтгаан нь эдгээр эсүүдийн нөхөн сэргээх чадвартай холбоотой юм. Хүүхэд төрсөн мөчөөс эхлэн эсүүд нь аажмаар хөгширч, өдөр бүр жижиг том хэмжээний мутациуд үүсдэг. Хүний дархлааны систем эсүүдийн мутациас сэргийлдэг хэдий ч, нас ахих тусам дархлааны эсүүдийн үйл ажиллагаа суларч, мутацийн үр дагавар илүү ихээр гарах боломжтой болдог.',
      ul: '',
      img2: cellbank2,
      img2_title: '',
      p4: 'Харин хүйн цус, эдийн үүдэл эсүүд нь цэвэр, алдаагүй эх эсүүдээс бүрдсэн байдаг. Эдгээр эсүүдийг  хадгалснаар ирээдүйд ямар нэгэн өвчин, эмгэг гарахад тухайн хүний ямар ч алдаагүй, залуу, эрүүл эх эсийг ашиглан эмчилгээ хийх боломжтой болдог. Энэ нь тухайн хүний эрүүл мэндийг хадгалах, өвчин эмгэгээс урьдчилан сэргийлэх болон илүү үр дүнтэй эмчилгээ хийхэд чухал үүрэг гүйцэтгэдэг бөгөөд хүйн цус, эдийн үүдэл эсүүд нь цэвэр, алдаагүй эх эсүүдээс бүрдсэн байдаг.',
      p5: 'Эсийн банкнуудын үндсэн зорилго нь эсийн нөөцийг урт хугацаанд хадгалж, эрүүл мэндийн салбарыг ирээдүйн эмчилгээнд бэлдэх явдал юм. Эсийн банк нь эмчилгээний тогтвортой хөгжлийг  хангах, өвчний эрсдэлээс хамгаалах, зардлыг бууруулах, анагаахын шинжлэх ухааны хамтын ажиллагааг дэмжих зэрэг олон давуу талтай. Энэхүү технологи нь эрүүл мэнд, судалгааны салбарт нэн чухал үүрэг гүйцэтгэж байна. ',
      highlightText4: 'Эсийн банкны төрөл ба зорилго',
      ul1: 'Эсийн банкнуудыг хадгалалтын зорилго, ашиглах боломж, эсийн гарал үүслээс нь хамааран дараах ангилалд хуваана:',
      li1: [
        {
          title: 'Public эсийн банк: ',
          desc: 'Засгийн газрын санаачилга, санхүүжилтээр олон нийтийн сайн дурын хандивын үндсэн дээр хадгалж, шаардлагатай өвчтөнүүд болон судалгаанд ашиглах зориулалттай. '
        },
        {
          title: 'Family эсийн банк: ',
          desc: 'Өөрийн болон гэр бүлийн гишүүдийн хэрэгцээнд зориулан эсээ хадгалуулах. Энэ нь ирээдүйд эрүүл мэндийн хэрэгцээндээ зориулж эсээ хадгалуулах, эзэмших боломжийг хувь хүмүүст олгодог. Өрөөр хэлбэр хадгалуулсан эс тухайн гэр бүлийн хувийн өмч юм. '
        },
        {
          title: 'Hybrid эсийн банк: ',
          desc: 'Public болон Family эсийн банкны хосолсон хэлбэр юм. '
        }
      ],
      highlightText5: 'Орчин үеийн дэвшил ба эсийн банкны ач холбогдол',
      ul2: 'Сүүлийн жилүүдэд эсийн хадгалалтын технологи хурдацтай хөгжиж байна. Тухайлбал:',
      li2: [
        {
          title: 'Криоген хадгалалт: ',
          desc: 'Хэт бага температурт (-196°C) эсийг удаан хугацаагаар гэмтээлгүй хадгалах технологи боловсронгуй болсоор байна.'
        },
        {
          title: '3D эсийн эсийн өсгөвөрлөлт ба био-принтин: ',
          desc: 'Хадгалсан эсүүдийг био-хэвлэх аргаар шинэ эд эс бий болгоход ашиглах боломж нээгдэж байна. '
        },
        {
          title: 'iPSC: ',
          desc: 'Энгийн эсийг генетикийн аргаар хувирган гэмтсэн эд, эрхтнийг сэргээхэд ашиглах боломжтой болж байна. '
        },
        {
          title: 'Ген засварлах технологи (CRISPR):  ',
          desc: 'Хадгалсан эсүүдийг удамшлын эмгэгүүдийг засахад ашиглах боломж улам бүр сайжирч байна.'
        }
      ],
      highlightText6: 'Эсийн банкны ирээдүй',
      p6: 'Эсийн банк нь орчин үеийн анагаах ухааны зайлшгүй нэг хэсэг болж, хувь хүний эрүүл мэндийг хамгаалах, анагаах ухааны ирээдүйг өөрчлөх чухал түлхүүр болж байна. Ирээдүйд хүмүүс эрүүл эсээ урьдчилан хадгалуулах нь даатгалтай адил хэвийн үзэгдэл болох магадлал өндөр байна.',
      p7: 'Та эсийн банкны ач холбогдлыг юу гэж бодож байна? Ирээдүйд эрүүл мэндээ хамгаалах зорилгоор эсээ хадгалуулах сонголтыг хийхэд бэлэн үү? '
    }
  },
  {
    id: 3,
    content: {
      date: '2025/02/11',
      headerText: 'ҮҮДЭЛ ЭСИЙН АНГИЛАЛ',
      highlightText: '',
      p1: 'Үүдэл эсүүд нь өөрийгөө олшруулах чадвартай, ялгаран хөгжөөгүй эсүүд бөгөөд олон төрлийн эс болж ялгаран хөгжих чадвартай.',
      img1: stemMain,
      img1_title: 'Зураг 1: Үүдэл эсийн ялгаран хөгжил',
      highlightText2: '',
      p2: 'Ялгаран хөгжих чадвараас нь хамаарч үүдэл эсүүдийг дараах байдлаар ангилж болно: ',
      highlightText3: '',
      table1_desc: 'Хүснэгт1: Үүдэл эсийн ангилал',
      table: {
        header: ['Ангилал', 'Үүдэл эсийн төрөл', 'Ялгаран хөгжих чадвар'],
        body: [
          [
            'Плюрипотент',
            ['Үр хөврөлийн үүдэл эс', 'Өдөөгдсөн плюрипотент эс'],
            'Бүх төрлийн эс'
          ],
          [
            'Мультипотент',
            ['Цусны үүдэл эс', 'Мезенхимийн үүдэл эс'],
            'Олон төрлийн эс'
          ],
          [
            'Олигопотент',
            [
              'Лимфойд эгнээний үүдэл эс',
              'Миелойд эгнээний үүдэл эс',
              'Мэдрэлийн үүдэл эс',
              'Арьсны эпидермисийн үүдэл эс',
              'Үсний фолликулын үүдэл эс',
              'Зүрхний үүдэл эс'
            ],
            'Цөөн төрлийн нэг эрхтний эс'
          ],
          [
            'Унипотент',
            [
              'Булчингийн үүдэл эс',
              'Меланоцитийн үүдэл эс',
              'Бэлгийн үүдэл эс'
            ],
            'Зөвхөн нэг төрлийн эс'
          ]
        ]
      },
      li3: [
        '1.	Плюрипотент эс нь үр хөврөлийн гурван давхаргын бүх эс болж хувирах чадвартай, лабораторийн нөхцөлд хязгааргүй үржих боломжтой бөгөөд үүнд үр хөврөлийн үүдэл эс, өдөөгдсөн плюрипотент эс (iPSC) багтана. Энэ төрлийн эсийн чадамж нь гайхалтай байдаг боловч зөвхөн үр хөврөлөөс ялгах боломжтой байдал, үр хөврөлийн гаралтай хавдар үүсгэх аюулаас болж эмчилгээнд өргөн ашиглагддаггүй. Харин өдөөгдсөн плюрипотент эс нь насанд хүрсэн хүний эсийг лабораторийн орчинд дахин программчилж гарган авдаг бөгөөд ёс зүйн асуудалгүйгээр, хөврөлийн үүдэл эстэй төстэй онцлог шинжийг нь хадгалдаг. Энэ аргыг анх 2006 онд Японы эрдэмтэн Шиня Яманака нээж, улмаар эмчилгээний шинэ чиг хандлагыг бий болгон хөгжүүлж байна.',
        '2.	Харин мультипотент эс нь зөвхөн зарим төрлийн эс болж хувирах чадвартай бөгөөд бие гүйцсэн үүдэл эс энэ бүлэгт хамаарна. Бие гүйцсэн үүдэл эс нь мезенхимийн үүдэл эс болон цусны үүдэл эс гэсэн 2 төрөл байдаг. Мезенхимийн үүдэл эсээс холбогч эд, яс, мөгөөрс, мэдрэл, дотор эрхтний эсүүд үүсдэг. Цусны үүдэл эсээс цусны эс, дархлааны эс үүсдэг. Бие гүйцсэн үүдэл эс нь хэвийн үед ихэвчлэн идэвхгүй төлөвт байдаг бөгөөд өвчин эсвэл эдийн гэмтэл үүсэх үед идэвхжиж, гэмтсэн эдийг нөхөн сэргээж, бие махбодод тэнцвэрийг хадгалах үүрэгтэй. Энэ төрлийн эсүүдийг эмчилгээнд ашиглахад аюулгүй үр дүнтэй байдаг учир ихэнх үүдэл эсийн эмчилгээ эдгээр эсүүдийг ашигладаг. Бие махбодид цусны үүдэл эс шавиа чөмөгт (улаан чөмөг), харин мезенхимийн үүдэл эс шар чөмөгт хадгалагдаж хэрэгтэй үед зарцуулагдаж байдаг. Селл Клиникт цусны үүдэл эсийг хүйн цуснаас ялган хадгалах, мезенхимийн үүдэл эсийг хүйн эдээс ялган хадгалах үйлчилгээ бий. Хүйн цус болон хүйн эдээс ялган шингэн азотод хадгалсан үүдэл эсүүд нь улаан болон шар чөмөгт буй эсүүдтэй харьцуулахад залуу, чадамж өндөртэй байдаг онцлогтой. ',
        '3.	Үүнээс гадна олигопотент, унипотент  гэсэн үүдэл эсүүд мөн бий. Эдгээр эсүүд нь зөвхөн цөөн төрлийн, нэг төрлийн эс болон ялгаран хөгжих чадвартай үүдэл эс юм. Арьсны эпидермисийн үүдэл эс, меланоцитийн үүдэл эс, үсний булцууны үүдэл эс, булчингийн үүдэл эс, зүрхний үүдэл эс, мэдрэлийн үүдэл эс зэрэг нь эдгээр эсүүдийн жишээ юм.'
      ],
      img2: stem,
      img2_title: 'Зураг 1: Үүдэл эсийн ялгаран хөгжил',
      img3: hair,
      img3_title: 'Зураг 2: Үсний булцуунд агуулагдах үүдэл эсүүд'
    }
  },
  {
    id: 4,
    content: {
      headerText: 'Үүдэл эсийн судалгааны түүх',
      highlightText: '',
      p1: 'Үүдэл эсийн судалгаа нь анагаах ухаан, Био Анагаах ялангуяа эсийн биологи, нөхөн төлжүүлэх анагаах ухааны хамгийн чухал ололтуудын нэг билээ. Энэ судалгааны үндэс суурь 19-р зууны дунд үеэс тавигдаж, 21-р зуунд эрхтэн нөхөн сэргээх болон ген эмчилгээний гол тулгуур болсон. Үүдэл эс (Stem Cell) гэх нэр томьёог анх шинжлэх ухааны бүтээлүүдэд 1868 онд Германы биологич Ernst Haeckel дурдсан. Ernst Haeckel нь Чарльз Дарвины хувьслын онолын гол дэмжигчдийн нэг байсан бөгөөд хувьслын үүсэл гарлыг "Stammbäume" (Герман хэлээр "удмын мод" буюу хувьслын мод) хэмээн дүрсэлсэн. Энэ хүрээнд тэрээр "Stammzelle" (Герман хэлээр үүдэл эс) гэсэн нэр томьёог ашиглаж эхэлсэн бөгөөд бүх олон эст организмуудыг үүсгэсэн нэг эст өвөг, дээд эс байдаг хэмээн тодорхойлжээ. 1892 онд судлаач Haeckel "үр тогтсон өндгөн эс бол үүдэл эс" гэсэн тодорхойлолтыг цааш хөгжүүлж, үр тогтсон өндгөн эсээс бүрэн ялгаран хөгжсөн үр хөврөлийн эс хүртэлх бүх эсүүдийг "үүдэл эс" гэж нэрлэх санал дэвшүүлсэн. Энэ нь хүн болон амьтны хөгжлийн эхлэл нь нэг эсээс үүсдэг гэдэг ойлголтыг байгалийн шинжлэх ухааны салбарт бүрэн бий болгож чадсан. 19-р зууны сүүл үеэс эрдэмтэд цусны эсүүд нэг төрлийн анхдагч эстэй эсэх талаар судалж эхэлсэн. ',
      img1: uudel_es,
      img_1: ernst,
      img_1_title: 'Ernst Haeckel 1834-1919',
      img_2: shinya,
      img_2_title: 'Shinya Yamanaka, Нобелийн шагналт',
      highlightText2: '',
      p2: 'Судлаач Paul Ehrlich 1879 онд будагч бодис ашиглан цусны эсүүдийг будаж үнэлэх аргыг нэвтрүүлсэн нь цусны нөхөн төлжлийг судалж буй судлаачдад цаашид цусны үүдэл эсийн талаар нээлт хийх маш том боломжийг бий болгосон. 1896 онд Artur Pappenheim цусны бүх эсүүдийг үүсгэх чадвартай анхдагч эсийн схемийг гаргаж, үүнийг үүдэл эс гэж нэрлэсэн. 1909 онд Оросын эрдэмтэн Alexander Maximow анх удаа цусны төлжүүлэх үүдэл эс (Hematopoietic Stem Cell, HSC) гэсэн нэр томьёог шинжлэх ухааны судалгаанд ашиглажээ. ',
      highlightText3: '',
      p3: '1950-иад онд Канадын эрдэмтэд James Till болон Ernest McCulloch нар цусны үүдэл эсүүд лабораторийн нөхцөлд шинэ эсүүд үүсгэдэг болохыг туршилтаар баталсан. Энэхүү нээлт нь үүдэл эсийн судалгаанд эргэлтийн цэг болсон юм. Дээрхээс харвал үүдэл эсийн тухай анхны ойлголтууд 19-р зууны сүүл үеэс үр хөврөлийн болон цус төлжүүлэх чиглэлийн судалгааны үндэс суурин дээр хөгжиж иржээ. 1981 онд Английн эрдэмтэн Martin Evans хулганы үр хөврөлийн үүдэл эсийг тусгаарлан авч, лабораторид ургуулсан бөгөөд энэхүү нээлтээр 2007 онд Нобелийн шагнал хүртсэн. Энэ цаг үеэс хүний үр хөврөлийн үүдэл эсийн (hESCs) чиглэлээр судалгааны ажлууд эрчимтэй хөгжиж, нөхөн сэргээх эмчилгээний шинэ боломжуудыг нээсэн.',
      ul: '',
      img2: '',
      img2_title: '',
      p4: '2006 онд Японы эрдэмтэн арьсны эсийг дахин программчилж индукцлэгдсэн плурипотент үүдэл эс (iPSC) анх гарган авч, энэхүү нээлтээрээ 2012 онд Нобелийн шагнал хүртсэн. Эдгээр судалгаа шинжилгээ, нээлт нь анагаах ухаан, биологийн салбарт эсийн нөхөн төлжилт, ген эмчилгээ, бүх төрлийн өвчин эмгэгийн эмчилгээнд хэрэглэх зэрэг олон чиглэлд хувьсгал авчирчээ.',
      p5: 'Тухайлбал хавдрын эмчилгээ (цусны хорт хавдрын үед ясны чөмөг шилжүүлэн суулгах), зүрх судасны өвчин (зүрхний булчингийн эсийг нөхөн сэргээх), мэдрэлийн эмгэг (Паркинсон, Альцгеймерийн өвчнийг эмчлэх), чихрийн шижин (инсулин ялгаруулах эсийг нөхөн сэргээх), хараа сэргээх (нүдний торлогийн эсийг нөхөн сэргээх), элэг, бөөрний өвчин (элэгний эс нөхөн төлжүүлэх туршилтууд) зэрэг эмгэгүүдийн эмчилгээнд албан ёсоор хэрэглэх болсон. Цаашид эрхтэн ургуулах, нөхөн сэргээх, эмийн туршилт, гений эмчилгээ, насжилтын эсрэг судалгаа зэрэг олон олон салбарт хөгжих асар их боломж байна. '
    }
  },
  {
    id: 5,
    content: {
      headerText: 'Хүйн цус яагаад гайхамшигтай вэ?',
      highlightText: '',
      p1: 'Хүүхдээ өлгийдөн авах тэр нандин агшинд хүүхдийн тань ирээдүйн эрүүл мэндийн баталгаа болох нэгэн үнэт баялаг дагаж ирдгийг та мэдэх үү?',
      img1: blood,
      highlightText2: '',
      p2: 'Энэ үнэт баялаг бол ХҮЙ бөгөөд түүнд хүний амьдралд байж болох хамгийн идэвхтэй, хамгийн залуу, хамгийн их хэмжээтэй цусны үүдэл эсүүд агуулагдаж байдаг. Эдгээр цусны үүдэл эсийг хадгалах нь тухайн хүүхдийн амьдралд хэзээ ч дахин давтагдахгүй боломж юм. ',
      highlightText3: '',
      p3: 'Энэ бол зүгээр шинжлэх ухаанч шийдвэр биш, ээж аав таны хүүхдийнхээ ирээдүйн эрүүл мэндийг баталгаажуулах гэсэн чин сэтгэлийн илэрхийлэл юм.',
      ul3: 'Яагаад хүйн цус хадгалуулах ёстой вэ?',
      li4: [
        'Одоо цагт цусны өвчнүүд, цусны хорт хавдрыг бүрэн эмчлэх гол түлхүүр болж байна.',
        'Ирээдүйд эмчлэгдэхгүй байгаа олон өвчнийг эмчлэх нөөц болно.',
        'Хөгшрөлтийг удаашруулах, гэмтэл, шарх эдгээх гэх мэт нөхөн сэргээх онцгой чадвартай.'
      ],
      ul: '',
      img2: blood3,
      img2_title: '',
      p4: 'Таны хүүхэд ирээдүйд юу тохиолдохыг бидний хэн нь ч мэдэхгүй. Хүүхдийн ирээдүйн баталгаа болгож хүүхдийнхээ хүйн цусны үүдэл эсийг хадгалуулах нь танд сэтгэл амар, амар тайван мэдрэмжийг өгнө.',
      p5: 'Бид Монголдоо анх удаа үүдэл эсийн банк байгуулж байгаа бөгөөд олон улсын стандартад нийцсэн эс боловсруулах, хадгалах GMP лабораторид хүйн цусны үүдэл эсүүдийг боловсруулан хадгалах үйлчилгээ үзүүлж байна.',
      video_url: 'https://www.youtube.com/embed/5x3l1kocryI?si=PAGNrOLMQlsdvW3y'
    }
  },
  {
    id: 6,
    content: {
      headerText: 'Хүний биеийн нууцлаг эрдэнэс: Эсийн банкны ач холбогдол',
      highlightText: '',
      p1: 'Амьд эсийг хөлдөөж хадгалах гайхамшиг.',
      img1: blood2,
      highlightText2: '',
      p2: 'Та хэзээ нэгэн цагт "амьд зүйлийг хөлдөөж хадгалж болдог" гэж сонсож байсан уу? Энэ нь зөвхөн уран зөгнөлт киноны сэдэв биш, бодит амьдрал дээр биологичид, эмч, биоанагаахын судлаач нар хийж чаддаг болсон шинжлэх ухааны шинэ технологи юм. Үүнийг крио-хадгалалт буюу эс, эд, үр хөврөл, эрхтэнийг хэт нам хүйтэн температурт гэмтээхгүйгээр хадгалах аргыг хэлнэ. Хөлдөөж хадгалах үйлдэлд хамгийн гол асуудал бол ус. Эс доторх ус хөлдөхдөө усны талст буюу кристал болж, эсийн бүтцийг гэмтээдэг. Харин шинжлэх ухаан үүнийг тойрох арга олжээ. Үүнийг шилэн-шилжүүлэлт (vitrification) хэмээн нэрлэдэг. Энэ нь усны дуслыг маш хурдан хөргөснөөр талст үүсгэх завдалгүйгээр "шилэн мэт хатуу" төлөвт оруулдаг арга юм. Гайхалтай нь, энэ санаа шинэ биш. Францын алдарт химич Жозеф Луи Гей-Люссак 1804 онд үүлэн доторх жижиг усны дуслууд хасах хэмд ч хөлдөөгүйг анзаарсан байдаг. Тэр үедээ л "бага хэмжээтэй ус хөлдөхгүй удаан хадгалагдаж болдог" гэдгийг ойлгож тэмдэглэн үлдээжээ. 1866 онд Италын физиологч, антропологич Paolo Mantegazza эр бэлгийн эс хөлдөөх оролдлого анх удаа амжилттай хийж, эр бэлгийн эсийн банкны санааг гаргасан.  Харин 1938 онд эрдэмтэн B.J. Luyet анхны амжилттай крио-хадгалалт хийсэн. Тэрээр мэлхийн үр хөврөлийг шингэн азотод хөлдөөгөөд, гэсгээхэд амьд үлдэж байсныг тогтоожээ. Энэ нь хүний үр хөврөл, өндгөн эс, цаашлаад бүр эрхтэнг хадгалах санааг нээж, цаашид эсийг хэрхэн гэмтээхгүй хадгалах талаар эрдэмтэд түлхүү ажиллаж эхэлсэн. Судлаач A. Arav нар "хамгийн бага дуслын" технологи аргыг боловсруулсан нь маш бага хэмжээтэй (0.07 мкл) дуслыг ашиглан эсийг гэмтээхгүй хөлдөөх боломжийг олгосон. Эс дотрох усны дуслын хэмжээ бага байх тусам дулаан хурдан дамжиж, талстжилт үүсэхгүй, улмаар эс гэмтэхээс сэргийлэх боломжтой. Хөлдөөж хадгалсан эсийг эргэж гэсгээхэд ч бас ухаан хэрэгтэй. Хэрвээ гэсгээлт удаан явагдвал өмнө нь зогсоож чадсан талстжилт дахин эхэлж, эсийг гэмтээж болдог. Тиймээс маш хурдан гэсгээлт хийдэг бөгөөд энэ арга өнөөдөр мөн хэдийнээ амжилттай нэвтэрсэн байна.  Ийнхүү шинжлэх ухаан амьдралыг "түр хугацаанд зогсоох", ирээдүйд эргэн сэргээж хэрэглэх боломжийг олгосон нээлтүүд өнөөдөр биелэлээ олж буй нь зүгээр л хөлдөөх биш - амьдралыг хойшлуулах урлаг болон хөгжижээ. ',
      highlightText3: '',
      p3: 'Хөлдөөсөн эсийг хадгалах, ирээдүйд хэрэглэх ойлголт нь "эсийн банк" хэмээх ухагдахууныг бий болгосон. Энгийнээр хэлбэл, эсийн банк гэдэг нь хүний эс, эд, үр хөврөл, эсвэл үүдэл эс зэргийг тусгай нөхцөлд, голчлон шингэн азотын хэт нам температурт хадгалдаг биоангаахын шинэ технологид суурилсан үйлчилгээ. Эсийн банк нь зөвхөн нэг төрөл биш бөгөөд олон төрлийн зориулалт, хэрэглээтэйгээр хөгжиж ирсэн.  ',
      img2: blood4,
      img2_title: '',
      p4: 'Эрт цагаас эхлэн анагаах ухаанд “хүний үр удмыг хадгалах” тухай ойлголт байсан хэдий ч XX зууныг хүртэл дорвитой үр дүнд хүрэхгүй л байсан. Эсийг удаан хугацаагаар хадгалж цаашид хэрэглэж болох талаар 1950-иад онд эрэгтэй хүний эр бэлгийн эсийг хадгалах зорилгоор эхэлсэн.  Тухайн үед хорт хавдрын хими эмчилгээний дараа нөхөн үржихүйн боломжоо бүрэн алддаг. Тиймээс нөхөн үржихүйг хадгалах хэрэгцээнээс бэлгийн эсийн банк хийх санаа урган гарсан.  Улмаар 1953 онд анхны бэлгийн эсийн банк АНУ-д байгуулагдаж, өвчтөнүүд өөрийнхөө бэлгийн эсийг хөлдөөж хадгалах боломжтой болсон. Үүнээс улбаалан эмэгтэйчүүдийн өндгөн эс, үр хөврөлийг хадгалах аргачлалууд шинээр бий болж, "үр хөврөлийн банк" хэмээх ойлголт үүсчээ. Орчин цагт нөхөн үржихүйн хадгалалт нь зөвхөн хавдрын эмчилгээний заалттай хүмүүс төдийгүй өрх толгойлсон эмэгтэйчүүд, гэр бүлгүй хүмүүс, эсвэл нөхөн үржихүйгээ хойшлуулах хүсэлтэй эмэгтэйчүүд бэлгийн эс болон үр хөврөл хадгалах хэрэгцээ гарч байгаа нь ирээдүйд генетикийн хувьд аав ээж байх боломжийг хүмүүст олгож байна. Насанд хүрсэн хүн төдийгүй өсвөр насны хорт хавдартай, хавдарын эмчилгээ хийлгэх шаардлагатай хүүхдүүдэд зориулан өндгөвчний эдийн хөлдөлт (ovarian tissue freezing) болон төмсөгний эдийн хадгалах (testicular tissue banking) технологи амжилттай хөгжиж анагаахын салбарт хэдийнээ нэвтрээд байна.',
      p5: 'Нөхөн үржихүйн салбарт амжилттай нэвтэрсэн хөлдөөж гэсгээх технологи нь цаашлаад 1990-ээд оноос эхлэн үүдэл эс салбарт хүч түрэн орж, үүдэл эсийг хадгалаж нөөцлөх болжээ. Үүдэл эс нь биеийн бүх төрлийн эсийг “үүсгэж чадах” онцгой чадвартай, ялгаран хөгжих өндөр чадамжтай эс юм. Биемахбодийн аль ч эд эрхтэн рүү хувирч хөгжих чадвартай тул анагаах ухаанд маш олон өвчнийг эмчлэх боломжийг агуулдаг гэж үздэг. Үүдэл эс нь хэд хэдэн төрөл байдаг бөгөөд хүүхэд төрөх үед хүйн цус болон хүйн эдэд их хэмжээтэй агуулагддаг. Хүйн цус болон хүйн эдээс гаргаж авсан үүдэл эсийг хадгалах боломжтой бөгөөд энэ нь тухайн хүүхдийн эрүүл мэндийг ирээдүйд хамгаалах чухал алхам билээ. ',
      p6: '1988 онд Францын Парис хотын L’Hôpital Saint-Louis эмнэлэгт нэгэн онцлох үйл явдал болсон нь хүйн цусны ач холбогдлыг анх дэлхийд харуулсан. Уг эмнэлэгт Fanconi anemia буюу цусны удамшлын ховор өвчтэй Matthew Farrow хэмээх хүүд донор олдоогүй тул түүний төрөх гэж буй дүүгийн хүйн цусыг ашиглан анхны үүдэл эсийн шилжүүлэн суулгах эмчилгээ хийжээ. Генетик шинжилгээгээр дүү нь Fanconi anemia өвчингүй, мөн дархлааны HLA бүрэн тохирсон донор болох нь батлагдсан тул хүйн цусыг түүний төрөх үеэр цуглуулж, шингэн азотод хадгалжээ. Улмаар АНУ-ын эмч, судлаач Hal Broxmeyer, Dr. Eliane Gluckman нар хамтран дүүгийн хадгалсан хүйн цусны үүдэл эсийг амжилттай шилжүүлэн суулгаж, 19 хоногийн дараа Matthew хүүгийн ясны чөмгийг бүрэн сэргэж, цусны эрүүл эсийг боловсруулж эхэлснээр Fanconi anemia өвчин бүрэн эдгэрчээ. Одоо Matthew Farrow 40 гаруй настай эрүүл саруул амьдарч байна. Энэ үйл явдал нь хүйн цусны банкаар дамжуулан амьдрал аврах боломж бодит гэдгийг дэлхий нийтэд баталсан анхны түүх юм.',
      p7: 'Үүдэл эс хадгалах нь ирээдүйд гарах олон өвчний эмчилгээнд хэрэглэх чухал алхам. Одоогоор анагаах ухаанд үүдэл эсийг ашиглан цусны хавдар, мэдрэлийн эмгэг, чөмөг шилжүүлэн суулгах, дархлааны өвчнийг эмчлэх судалгаа, эмчилгээний шинэ үеийг бий болгож байгаа нь крио-хадгалалт өнгөрсөн зуунд шинжлэх ухааны гайхамшигт дэвшил байсныг өнөөдөр хүн бүрийн ирээдүйн амьдралд хамаатай технологи болон хувирчээ.',
      p8: 'Эсийн банк нь зөвхөн амьдрал хадгалах бус, амьдрал бүтээх, амьдрал хамгаалах шинжлэх ухааны илэрхийлэл юм. Монголчууд бид ч энэ хөгжилтэй хөл нийлүүлэн алхаж, өөрсдийн болон үр хүүхдийнхээ ирээдүйд зориулан төрөх үед хүйн цус болон хүйн үүдэл эсийг хадгалалуулах бүрэн боломжтой бөгөөд энэ нь энгийн хүн бүрт хамааралтай ирээдүйн эрүүл мэндийн даатгал юм. ',
      p9: 'Та өөрийн амьдралыг хөлдөөж хадгалах цаг ирлээ гэж төсөөлж ч байсан уу? Төсөөлөхөөс ч илүү — энэ бол өнөөдөр хийж болох амьдралын хамгийн ухаалаг шийдвэрүүдийн нэг юм.'
    }
  },
  {
    id: 7,
    content: {
      headerText:
        'Селл Клиник – SciCon 2025 Шинжлэх ухаанд шимтэгсдийн баярт амжилттай оролцлоо',
      highlightText: '',
      p1: 'Манай эмнэлэг  нь Монголын шинжлэх ухаанд шимтэгчдийн хамгийн том баяр болох SciCon – Science Conference 2025: Quantum Era арга хэмжээг “Gej Yu Ve?”-ын залуустай хамтран зохион байгуулж оролцож, шинжлэх ухааны боловсролыг олон нийтэд таниулах үйлсэд хувь нэмэр орууллаа.',
      img1: sc2,
      highlightText2: '',
      p2: 'Энэхүү наадам 2025 оны 4-р сарын 20-ны өдөр Соёлын төв өргөөнд амжилттай зохион байгуулагдсан бөгөөд шинжлэх ухааныг олон нийт, ялангуяа хүүхэд, залуучуудад ойлгомжтой, сонирхолтой хэлбэрээр хүргэхийг зорьсон, танин мэдэхүйн онцгой арга хэмжээ байв.',
      p3: 'Селл Клиник нь нийгмийн хариуцлагын хүрээнд дараах хэлбэрээр оролцсон юм:',
      d1: {
        name: '🎙 “Эсийн гайхамшиг” сэдэвт илтгэл:',
        desc: 'Бид эсийн эмчилгээ, түүний шинжлэх ухааны үндэс, ирээдүйн боломжуудыг энгийн ойлгомжтой байдлаар тайлбарлаж, хүүхэд, залуус болон олон нийтэд эсийн шинжлэх ухааныг таниулахад чиглэсэн танин мэдэхүйн илтгэл тавилаа.'
      },
      d2: {
        name: '💬 “Юрын галавын цэцэрлэг эргэн ирэх үү?” сэдэвт хэлэлцүүлэг:',
        desc: 'Биотехнологийн хурдацтай хөгжил, ёс зүйн асуудал, ирээдүйн боломжуудын талаар өргөн хүрээтэй хэлэлцүүлэгт оролцож, шинжлэх ухааны ирээдүйн чиг хандлагын талаарх ойлголтыг олон нийттэй хуваалцлаа.'
      },
      p4: 'Селл Клиник нь шинжлэх ухааны боловсролыг дэмжих үйл ажиллагааг зөвхөн салбарын хөгжил төдийгүй нийгмийн ирээдүйг хамтдаа бүтээлцэх чухал алхам гэж үздэг. Бид цаашид ч ирээдүйн судлаачдыг дэмжиж, шинжлэх ухааныг түгээх үйлсэд бодитой хувь нэмэр оруулахын төлөө ажиллах болно. ',
      img2: sc2_1,
      img4: sc2_es,
      img5: sc2_u,
      img2_title: '',
      p5: 'CellClinic – Эсийн шинжлэх ухааныг хуваалцаж, ирээдүйн судлаачдыг дэмжинэ.'
    }
  }
]

export default function NewsDetail () {
  const { id } = useParams()
  const [isScrolled, setIsScrolled] = useState(false)
  const [text, setText] = useState('')

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const callNavigate = () => {
    navigator.clipboard.writeText(`https://cellclinic.mn/news/${Number(id)}`)
    setText('ХУУЛАГДЛАА')
  }
  const newsData = newsList.find(item => item.id === Number(id)).content

  if (!newsData) {
    return <p>Мэдээлэл олдсонгүй</p>
  }
  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>

      <div className='self-stretch bg-[#f7fbff]  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto maxScreen:px-0 extraScreen:px-0'>
        {/* <Header color='blue' gradientColor='white' /> */}
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : '#235998'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-white'}
          />
        </div>
        <main className='flex flex-col mobile:p-1 p-10'>
          <div
            className='flex flex-col justify-end h-[50vh] bg-cover bg-center bg-no-repeat w-full rounded-2xl mobile:h-[30vh]'
            style={{ backgroundImage: `url(${newsData.img1})` }}
          ></div>
          <div className='flex flex-row justify-between p-10 mobile:p-2 w-full items-center'>
            <div className=''>
              <div className='text-[#215998] ml-2 text-sm '>
                <p>Нийтэлсэн</p>
                <div className='flex flex-row items-center gap-2'>
                  <div className='h-10 w-10'>
                    <img src={logo} alt='olo' />
                  </div>
                  <p className='text-black'>{newsData.date}</p>
                </div>
              </div>

              {/* <Text className='text-white w-[90%] mt-5 text-lg'>
                CELLCLINIC ЭСИЙН БАНК & ЭСИЙН ЭМЧИЛГЭЭНИЙ ЭМНЭЛЭГ АЛБАН ЁСООР ҮҮД ХААЛГАА НЭЭЛЭЭ 
                </Text> */}
            </div>

            <span className='text-[10px] absolute top-[540px] ml-[980px]'>
              {text}
            </span>
            <button
              className='flex h-10 min-w-[60px] w-[160px] text-[14px] px-0 justify-center items-center gap-0 rounded-lg border border-[rgba(255,255,255,0.16)] bg-white text-[#215998] '
              onClick={callNavigate}
            >
              <img
                src={door}
                alt='Door Icon'
                className='h-4 w-4'
                style={{
                  filter:
                    'brightness(0) saturate(100%) invert(20%) sepia(70%) saturate(500%) hue-rotate(180deg)',
                  marginRight: 10
                }}
              />
              Линк хуулах
            </button>
          </div>
          {/* body section */}

          <div>
            <div className='flex flex-col w-[720px] mx-auto mobile:w-full mobile:p-5 mobile:mt-0 text-justify'>
              <div className='text-[22px] font-medium text-center'>
                {newsData.headerText}
              </div>
              <div className='text-xl font-bold mt-18'>
                {newsData.highlightText}
              </div>
              <div className='text-base font-normal mt-5'>{newsData.p1}</div>
              {newsData.img_1 && (
                <div className='text-base font-normal mt-5 flex flex-row justify-between mb-4 h-[400px] mobile:h-[200px] w-full mobile:mb-4'>
                  <div className='w-[300px] mobile:w-[200px] '>
                    <img
                      src={newsData.img_1}
                      alt='dsssk'
                      className='h-full w-full mobile:h-full rounded-xl'
                    />
                    <p style={{ textAlign: 'center' }}>
                      {newsData.img_1_title}
                    </p>
                  </div>
                  <div className=' ml-10 w-[300px] mobile:w-[200px]'>
                    <img
                      src={newsData.img_2}
                      alt='dsssk'
                      className='h-full w-full mobile:h-full rounded-xl'
                    />
                    <p>{newsData.img_2_title}</p>
                  </div>
                </div>
              )}
              {newsData.img2 && (
                <div className='text-base font-normal mt-5 flex justify-center'>
                  <img
                    src={newsData.img2}
                    alt='dsssk'
                    className='h-full w-full mobile:h-full rounded-xl'
                  />
                </div>
              )}
              <div className='text-sm font-normal mt-2'>
                {newsData.img1_title}
              </div>
              {/* <div className='text-xl font-bold mt-10'>
                {newsData.highlightText2}
              </div> */}
              <div className='text-base font-normal mt-5'>{newsData.p3}</div>
              {/* <div className='text-xl font-bold mt-10'>
                {newsData.highlightText3}
              </div> */}
              {newsData.d1 && (
                <div className='text-base font-normal mt-5 '>
                  <p className='font-bold'>{newsData.d1.name}</p>
                  <p>{newsData.d1.desc}</p>
                </div>
              )}
              {newsData.img4 && (
                <div className='text-base font-normal mt-5 flex justify-center'>
                  <img
                    src={newsData.img4}
                    alt='dsssk'
                    className='h-full w-full mobile:h-full rounded-xl'
                  />
                </div>
              )}
              {newsData.d2 && (
                <div className='text-base font-normal mt-5 '>
                  <p className='font-bold'>{newsData.d2.name}</p>
                  <p>{newsData.d2.desc}</p>
                </div>
              )}
              {newsData.img5 && (
                <div className='text-base font-normal mt-5 flex justify-center'>
                  <img
                    src={newsData.img5}
                    alt='dsssk'
                    className='h-full w-full mobile:h-full rounded-xl'
                  />
                </div>
              )}
              {newsData.p2 && (
                <div className='text-base font-normal mt-5 '>{newsData.p2}</div>
              )}

              {newsData.p4 && (
                <div className='text-base font-normal mt-5 '>{newsData.p4}</div>
              )}
              {newsData.p5 && (
                <div className='text-base font-normal mt-5 '>{newsData.p5}</div>
              )}
              {newsData.table && newsData.table && (
                <table className='news-table border border-gray-200 mt-5 '>
                  <thead>
                    <tr className='border border-gray-200 mobile:text-[12px]'>
                      {newsData.table.header.map((headerItem, index) => (
                        <th
                          key={index}
                          className='border border-gray-200 text-center'
                        >
                          {headerItem}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='border border-gray-200'>
                    {newsData.table.body.map((row, index) => (
                      <tr key={index} className='border border-gray-200'>
                        {row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className='border border-gray-200 text-[12px]'
                          >
                            {Array.isArray(cell) ? (
                              <ul className='ml-2'>
                                {cell.map((subItem, subIndex) => (
                                  <li key={subIndex}>{subItem}</li>
                                ))}
                              </ul>
                            ) : (
                              <p className='ml-2'>{cell}</p>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {newsData.table1_desc && (
                <div className='text-base font-normal mb-5 '>
                  {newsData.table1_desc}
                </div>
              )}
              {newsData.li3 &&
                newsData.li3.map((benefit, index) => (
                  <div key={index} className='mb-2 '>
                    <span className='font-normal'>{benefit}</span>
                  </div>
                ))}
              {newsData.highlightText5 && (
                <div className='text-xl font-bold mt-4'>
                  {newsData.highlightText4}
                </div>
              )}
              <p className=' mt-2'>{newsData.ul1}</p>
              {newsData.li1 && (
                <ul className='list-disc pl-5 mt-2'>
                  {newsData.li1.map((benefit, index) => (
                    <li key={index} className='mb-2 font-bold'>
                      {benefit.title}{' '}
                      <span className='font-normal'>{benefit.desc}</span>
                    </li>
                  ))}
                </ul>
              )}
              {newsData.highlightText5 && (
                <div className='text-xl font-bold mt-4 '>
                  {newsData.highlightText5}
                </div>
              )}
              <p className=' mt-2'>{newsData.ul2}</p>
              {newsData.li1 && (
                <ul className='list-disc pl-5 mt-2'>
                  {newsData.li1.map((benefit, index) => (
                    <li key={index} className='mb-2 font-bold'>
                      {benefit.title}
                      <span className='font-normal'>{benefit.desc}</span>
                    </li>
                  ))}
                </ul>
              )}
              {newsData.li2 && (
                <ul className='list-disc pl-5 mt-2'>
                  {newsData.li2.map((item, index) => (
                    <li key={index} className='mb-2 font-bold'>
                      {item.title}
                      <span className='font-normal'>{item.desc}</span>
                    </li>
                  ))}
                </ul>
              )}
              <p className=' mt-2'>{newsData.ul3}</p>
              {newsData.li4 && (
                <ul className='list-disc pl-5 mt-2'>
                  {newsData.li4.map((item, index) => (
                    <li key={index} className='mb-2'>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {newsData.highlightText6 && (
                <div className='text-xl font-bold mt-4'>
                  {newsData.highlightText6}
                </div>
              )}
              {newsData.img3 && (
                <div className='text-base font-normal mt-5 flex justify-center'>
                  <img
                    src={newsData.img3}
                    alt='dsssk'
                    className='h-full w-full mobile:h-full rounded-xl'
                  />
                </div>
              )}
              {newsData.img3_title && (
                <div className='text-sm font-normal mt-2'>
                  {newsData.img3_title}
                </div>
              )}
              {newsData.p6 && (
                <div className='text-base font-normal mt-4'>{newsData.p6}</div>
              )}
              {newsData.p7 && (
                <div className='text-base font-normal mt-4 mb-5'>
                  {newsData.p7}
                </div>
              )}
              {id === '3' && (
                <p className='mt-5'>
                  Селл Клиник нь арьсанд агуулагдах арьсны эпидермис,
                  меланоцитийн үүдэл эсийг арьсны бусад эсүүдтэй хамт ялган
                  гэмтсэн арьсыг нөхөн төлжүүлэх, гоо сайханд хэрэглэдэг
                  <a
                    href='https://cellclinic.mn/therapy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-500 underline'
                  >
                    {' '}
                    SprayCell
                  </a>
                  ,
                  <a
                    href='https://cellclinic.mn/therapy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-500 underline'
                  >
                    {' '}
                    SkinCell
                  </a>{' '}
                  гэх бүтээгдэхүүнүүдийг бий болгож байгаагаас гадна үсний
                  булцуу, нейрал крест үүдэл эс, арьсны хөхлөгийн гаралтай
                  мезенхим, арьс, меланоцитын үүдэл эсийг хуйхны бусад эстэй
                  хамт ялган эмчилгээнд хэрэглэдэг үс ургуулж, бэхжүүлдэг{' '}
                  <a
                    href='https://cellclinic.mn/therapy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-500 underline'
                  >
                    {' '}
                    HairCell
                  </a>{' '}
                  гэсэн бүтээгдэхүүн бий.
                </p>
              )}
              {newsData.video_url && (
                <iframe
                  width='100%'
                  height='405px'
                  src={newsData.video_url}
                  title='YouTube video player'
                  frameborder='0'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerpolicy='strict-origin-when-cross-origin'
                  allowfullscreen
                ></iframe>
              )}
            </div>
          </div>
        </main>
      </div>
      <div className='px-20 mobile:px-5  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto maxScreen:px-0 extraScreen:px-0'>
        <ConnectUs />
        <FooterSection />
      </div>
    </>
  )
}
